import { useDeliveryApi } from 'infrastructure/api';
import { useCrudService } from 'framework/crud';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import { downloadFile } from 'framework/utils';

const useEVMService = () => {
  const singleResourceUrl = '/projects/:id';
  const {
    search: baseSearch,
    update: initialUpdate,
    ...baseCrudRequests
  } = useCrudService({
    singleResourceUrl,
    listResourceUrl: '/projects',
    useService: useDeliveryApi,
  });

  const { sendGetRequest, uploadFile } = useDeliveryApi();
  const { addMessage } = useMessageService();

  const getEVMById = async (projectId: string): Promise<any> => {
    const response = await sendGetRequest(`/projects/${projectId}/evms`);
    return response.json();
  };

  const uploadEVMFile = async (projectId: string, file: File): Promise<any> => {
    const formData = new FormData();
    formData.append('file', file);

    const result = await uploadFile({
      url: `/projects/${projectId}/evms/upload`,
      data: formData,
    });

    if (result && result.response) {
      if (result.response.json && typeof result.response.json === 'function') {
        try {
          const jsonData = await result.response.json();
          return jsonData;
        } catch (jsonError) {
          return result.response;
        }
      } else {
        return result.response;
      }
    } else {
      return result;
    }
  };

  const downloadEVMFile = async (projectId: string): Promise<any> => {
    try {
      const response = await sendGetRequest(`/projects/${projectId}/evms/download`);

      if (!response) {
        return;
      }

      return downloadFile(response, 'evm.xlsx', false);
    } catch (err) {
      addMessage(new ErrorMessage('Error downloading EVM file'));
    }
  };

  return {
    ...baseCrudRequests,
    getEVMById,
    uploadEVMFile,
    downloadEVMFile,
  };
};

export default useEVMService;
